export default function obtenDiasLaborables(numero) {
    const fechas = []

    function esLaborable(fecha) {
        switch (fecha.getDay()) {
            case 6:
            case 0:
                return false
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
                return true
        }
    }

    function formatarFecha(fecha) {
        return fecha.getFullYear() + '-' + ('0' + (fecha.getMonth() + 1)).slice(-2) + '-' + ('0' + fecha.getDate()).slice(-2)
    }

    let hoy = new Date()
    while (fechas.length < numero) {
        let diaActual = hoy
        diaActual.setDate(diaActual.getDate() + 1)
        if (esLaborable(diaActual)) fechas.push( formatarFecha(diaActual) )
        hoy = diaActual
    }

    return fechas
}